import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'syngenta-react-components'
import clear from '../../assets/icons/clear.svg'
import Select from '../../dpe-usco/components/Select/Select'
import {
  getUserRoles,
  inviteUser,
  getUserProfile,
  searchUsers,
  addNewUser
} from '../../services/apiHelper'
import { useForm } from 'react-hook-form'
import TypeAhead from '../../dpe-usco/components/TypeAhead/TypeAhead'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'

const NewAdminForm = ({ handleCreate, handleCancel }) => {
  const [activeRole, setActiveRole] = useState()
  const [existingUsers, setExistingUsers] = useState()
  const [rolesData, setRolesData] = useState()
  const [roleOptions, setRoleOptions] = useState([])
  const [roleId, setRoleID] = useState()
  const [selectedUser, setSelectedUser] = useState()
  const [showRequired, setShowRequired] = useState(false)
  const [selectedFromSearch, setSelectedFromSearch] = useState()
  const [stopSearch, setStopSearch] = useState(false)
  const [submissionState, setSubmissionState] = useState()
  const [errorMsg, setErrorMsg] = useState('')
  const {
    register,
    errors,
    clearError,
    handleSubmit,
    reset,
    setValue,
    watch
  } = useForm({})

  const watchUserName = watch('name', '')

  const canceled = useRef(false)
  useEffect(() => {
    return () => {
      canceled.current = true
    }
  }, [])

  useEffect(() => {
    if (watchUserName.length > 2 && !stopSearch) {
      searchUsers(watchUserName, 'full_name' && 'email').then(res => {
        if (res.length && !canceled.current) {
          setExistingUsers(res)
        } else if (!res.length && !canceled.current) {
          searchUsers(watchUserName, 'email').then(res => {
            if (res && !canceled.current) {
              setExistingUsers(res)
            }
          })
        }
      })
      if (!canceled.current) {
        setStopSearch(true)
      }
    }
  }, [watchUserName, stopSearch])

  useEffect(() => {
    const initData = () => {
      getUserRoles().then(res => {
        if (!canceled.current) {
          const adminRoles = res.filter(role => role.role_type === 'admin')
          setRolesData(adminRoles)
        }
      })
    }
    initData()
  }, [setRolesData])

  useEffect(() => {
    if (rolesData) {
      const roleNames = rolesData.map(role => {
        return role.role_name
      })
      setRoleOptions(roleNames)
    }
  }, [rolesData])

  useEffect(() => {
    if (rolesData && activeRole) {
      const matchedRoleId = rolesData
        .filter(role => activeRole === role.role_name)
        .map(role => {
          return role.role_id
        })
      setRoleID(matchedRoleId)
    }
  }, [activeRole, rolesData])

  const roleSelection = value => {
    setActiveRole(value)
    setShowRequired(false)
  }

  const userSelection = value => {
    setSelectedUser(value)
  }

  const verifyExistingUser = async email => {
    const data = await getUserProfile(email)

    if (!data) {
      setSubmissionState('FAILED')
      setErrorMsg(`User ${email} not found.`)
      return
    }

    let role_id = roleId[0]
    let company_id = 'admin'
    let user_id = data.user_id
    const response = await inviteUser({ role_id, company_id, user_id })

    if (!canceled.current) {
      if (response.status > 300) {
        setSubmissionState('FAILED')
        setErrorMsg(response.data.errors[0].message)
      } else {
        setSubmissionState('SUCCESS')
      }
      reset()
      clearError()
    }
  }

  const createUser = async formValues => {
    const response = await addNewUser(formValues)
    if (response.status > 300) {
      setSubmissionState('FAILED')
      setErrorMsg(response.data.errors[0].message)
    } else {
      let role_id = roleId[0]
      let company_id = 'admin'
      let user_id = response
      let nuresponse = await inviteUser({ role_id, company_id, user_id })
      if (!canceled.current) {
        if (nuresponse.status > 300) {
          setSubmissionState('FAILED')
          setErrorMsg(nuresponse.data.errors[0].message)
        } else {
          setSubmissionState('SUCCESS')
        }
        reset()
        clearError()
      }
    }
  }

  const onSubmit = formValues => {
    setSubmissionState('LOADING')

    if (activeRole) {
      if (selectedUser === 'existing_user') {
        verifyExistingUser(selectedFromSearch || formValues.name)
      } else if (selectedUser === 'new_user') {
        createUser(formValues.email)
      }
    } else {
      setShowRequired(true)
    }
  }

  const handleCancelModal = () => {
    setSubmissionState()
    reset()
    setActiveRole(null)
    setShowRequired(false)
    clearError()
    handleCancel()
  }

  const _nameCallback = val => {
    setValue('name', val.name)
    setSelectedFromSearch(val.user_email)
  }

  const modalDecider = () => {
    if (selectedUser && !submissionState) {
      return (
        <div className="p16 df jcsb fxdrc fxww bd1-s-lightgray bdrs-4 m15">
          <div className="df fxdrr jcsb">
            <div className="w45% tal">
              <label className="fz13">Role*</label>
              <div className="fz15">
                <Select
                  placeholder={'Select role'}
                  handleSelection={roleSelection}
                  options={roleOptions}
                ></Select>
              </div>
              <div className="c-red tal fz13 pl4">
                {showRequired ? 'Please select a role for this user' : null}
              </div>
            </div>
            <div className="w45% tal">
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="tal w45%"></div>
                {selectedUser === 'new_user' ? (
                  <div>
                    {' '}
                    <label className="fz13">Email*</label>
                    <input
                      name="email"
                      ref={register({
                        required: true,
                        pattern: /^([a-zA-Z0-9_\-.]+)@([a-zA-Z0-9_\-.]+)\.([a-zA-Z]{2,5})$/
                      })}
                    />
                  </div>
                ) : (
                  <div className="mt20">
                    <TypeAhead
                      className="fz15 lh1.4"
                      id="name"
                      name="name"
                      placeholder="Search user"
                      ref={register({ required: true })}
                      item_id="user_id"
                      item_value="name"
                      item_value_additional="user_email"
                      data={existingUsers}
                      callback={_nameCallback}
                      onChange={() => setStopSearch(false)}
                    />
                  </div>
                )}
                <div className="c-red tal fz13 pl4">
                  {errors.email &&
                    errors.email.type === 'required' &&
                    'Please provide email address'}
                  {errors.email &&
                    errors.email.type === 'pattern' &&
                    'This email appears to be invalid. Please check if anything is missing'}
                </div>
              </form>
            </div>
          </div>
        </div>
      )
    } else if (submissionState === 'LOADING') {
      return <TableStatus status={'LOADING'} />
    } else if (submissionState === 'SUCCESS') {
      return (
        <div>
          <p>Successfully added new admin</p>
        </div>
      )
    } else if (submissionState === 'FAILED') {
      return (
        <div>
          <p>Failed to add admin</p>
          <p>{errorMsg}</p>
        </div>
      )
    }
  }

  return (
    <div>
      <div className="w100% h100% bgc-white bd1-s-lightgray bxshmodal bdrs-4">
        <div className="df jcsb">
          <p className="fz16 ml16 fw600">Invite admin</p>
          <button className="bdnone m0 bgc-t" onClick={handleCancelModal}>
            <img src={clear} alt="cancel button" />
          </button>
        </div>
        <hr className="mt0 mb16 bdnone bt1-s-lightgray" />
        <div className="df fxdrr aifs">
          <input
            type="radio"
            id="existing_user"
            name="user_type"
            value="existing_user"
            onChange={() => userSelection('existing_user')}
            className="pt5 ml15 tal w5%"
          />
          <label htmlFor="existing_user">Existing user</label>
        </div>
        {selectedUser === 'existing_user' ? modalDecider() : null}
        <div className="df fxdrr aifs">
          <input
            type="radio"
            id="new_user"
            name="user_type"
            value="new_user"
            onChange={() => userSelection('new_user')}
            className="pt5 ml15 tal w5%"
          />
          <label htmlFor="new_user">New user</label>
        </div>
        {selectedUser === 'new_user' ? modalDecider() : null}
        <hr className="mt20 mb16 bdnone bt1-s-lightgray" />
        <div className="df jcfe">
          {!submissionState && (
            <>
              <Button
                text="Cancel"
                customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
                clickHandler={handleCancelModal}
              ></Button>
              <Button
                type="success"
                text="Invite user"
                clickHandler={handleSubmit(onSubmit)}
                customClassName="mb8 mr8 pl16 pr16 pb10 pt10 fz16 fw600 bdrs-4"
              ></Button>
            </>
          )}
          {submissionState && (
            <Button
              customClassName="mr25 mt20"
              styleType="success"
              onClick={handleCancelModal}
            >
              Close
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default NewAdminForm
